import React, { useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";

import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import FormBox from "../../component/FormBox/FormBox";
import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    InputLabel,
    makeStyles,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from "@material-ui/core";
import errorWarning from "../../images/icon_warning.gif";
import { isEmpty, isNotEmpty } from "../../Utils";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentStep, setFieldValues } from "../../redux/action";
import { getFieldValues, getFormId } from "../../redux/selector";
import ErrorMsg from "../../component/ErrorMsg/ErrorMsg";
import FileInput from "../../component/FileInput/FileInput";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

export default function Confirmation() {
    const formId = useSelector(getFormId());
    const stepName = "Confirmation";

    const { t, i18n } = useTranslation();
    const classes = useStyles();

    const dispatch = useDispatch();
    let fieldValues = useSelector(getFieldValues());
    const { Input } = fieldValues;

    const onPrev = () => {
        dispatch(setCurrentStep("InputSample"));
    };

    const getFieldDisplay = (label, content) => {
        return (
            <Box mb={6}>
                <Typography variant="body1">{label}</Typography>
                <Typography variant="body1" className="bold">
                    {content}
                </Typography>
            </Box>
        );
    };

    return (
        <>
            <FormBox
                header={t("some_translation.key", stepName)}
                key={stepName}
            >
                <Box p={5}>
                    {getFieldDisplay(
                        t("some_translation_key", "身份證號碼"),
                        Input.hkid
                    )}
                    {getFieldDisplay(
                        t("some_translation_key", "金額"),
                        Input.price
                    )}
                    {getFieldDisplay(
                        t("some_translation_key", "重量"),
                        Input.weight
                    )}
                    {getFieldDisplay(
                        t("some_translation_key", "電話號碼"),
                        Input.phoneNo
                    )}
                    {getFieldDisplay(
                        t("some_translation_key", "電郵地址"),
                        Input.email
                    )}
                </Box>
            </FormBox>
            <FormBox>
                <Box display="flex" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        color="secondary"
                        className="secBtn"
                        onClick={() => onPrev()}
                    >
                        {t("common.button.back")}
                    </Button>
                    <Button variant="contained" color="primary" type="submit">
                        {t("common.button.next")}
                    </Button>
                </Box>
            </FormBox>
        </>
    );
}
